import styled from '@emotion/styled'

export const Title = styled('p')`
  font-weight: 400;
  font-size: 24px;
`
